import Application from "../../Application";

var table = null;

export default function() {
    manageCreateCommission();
    $(document).on('blur', 'input[name="budget"]', function(){
        let val = $(this).val();
        if(val == ''){ return false; }
        let sanitazed_input = parseInt(val.replaceAll('.', ''));
        let parsed_valued = Application.Common.formatNumber(sanitazed_input, 2, ',', '.');
        $(this).val(parsed_valued);
    });
    $(document).on('focus', 'input[name="budget"]', function(){
        let val = $(this).val();
        if(isNaN(parseInt(val))){ return false; }
        $(this).val(Application.Common.formattedNumberToInt(val, ',', '.'));
    });

    allSameHeight();

    showDonationDetail();

    var today = new Date();
    var endDate = new Date();
    endDate.setMonth(endDate.getMonth() + 3);
    $('input[name="dates"]').daterangepicker({
        startDate: today,
        endDate: endDate,
        locale: {
            format: 'DD/MM/YYYY',
            applyLabel: 'Applica',
            cancelLabel: 'Annulla',
            fromLabel: 'Da',
            toLabel: 'A',
            customRangeLabel: 'Custom',
            daysOfWeek: [
                'Dom',
                'Lun',
                'Mar',
                'Mer',
                'Gio',
                'Ven',
                'Sab'
            ],
            monthNames: [
                'Gennaio',
                'Febbraio',
                'Marzo',
                'Aprile',
                'Maggio',
                'Giugno',
                'Luglio',
                'Agosto',
                'Settembre',
                'Ottobre',
                'Novembre',
                'Dicembre'
            ],
            firstDay: 1
        }
    });

    table = Application.Common.manageCommissionsTable();
}

function manageCreateCommission(){
    if(!$('#build-commission').length){ return false };
    let tab = $('#build-commission').data('tab');
    showTab(tab); // Display the current tab
    $(document).on('click', '#prevBtn', () => { nextPrev(-1) });
    $(document).on('click', '#nextBtn', () => { nextPrev(1) });
    $(document).on('click', '.step', function(){
        let index = $(this).data('step');
        $('.tab').css('display', 'none');
        $('#build-commission').data('tab', index);
        showTab(index);
    });
}

function showDonationDetail(){
    $(document).on('click', '.show-donation-detail', function(){
        if($(this).hasClass('closed')){
            $('.show-donation-detail').addClass('closed');
            $(this).removeClass('closed');
            let data = {
                'Bol_DataBusta': $(this).data('busta-data'),
                'Bol_TipoVersBusta': $(this).data('busta-tipo-vers'),
                'Bol_CausaleBusta': $(this).data('busta-causale'),
                'Bol_CodOfferta': $(this).data('busta-offerta')
            };
            const elem = $(this).closest('tr').next().find('td');
            console.log(elem);
            $.ajax({
                'url': '/ajax/donation-detail',
                'method': 'POST',
                'data': data,
                'success': function(result){
                    if(result.success){
                        let html = '<div class="donation-detail-container">';
                        for(let partition of result.donation_detail){
                            html += '<div>' + partition.CdC_DesItaliano + ' - ' + Application.Common.formatNumber(partition.BolCdC_ImportoCdC, 2, ',', '.') + ' €</div>';
                        }
                        html += '</div>';
                        elem.append(html);
                    }
                    elem.parent().removeClass('d-none');
                },
                'error': function(error){
        
                }
            });
        } else {
            $(this).closest('tr').next().find('td').empty();
            $(this).closest('tr').next().addClass('d-none');
            $(this).addClass('closed');
        }
    });
}

function showTab(n) {
    let active_tab = $('.tab').eq(n);
    active_tab.css('display', 'block');

    if (n == 0) {
      $("#prevBtn").css('display', 'none');
    } else {
      $("#prevBtn").css('display', 'inline');
    }
    if (n == ($('.tab').length - 1)) {
      $("#nextBtn").html("Crea");
    } else {
      $("#nextBtn").html("Avanti");
    }
    fixStepIndicator(n)
}
  
function nextPrev(n) {
    if (n == 1 && !validateForm()) {return false};
    let index = $('#build-commission').data('tab');
    let active_tab = $('.tab').eq(index);
    active_tab.css('display', 'none');
    index = index + n;
    $('#build-commission').data('tab', index);
    if (index >= $('.tab').length) {
        createCommission();
    } else {
        showTab(index);
    }
}
  
function fixStepIndicator(n) {
    $('.step').removeClass('active');
    $('.step').eq(n).addClass('active');
}

function createCommission(){
    $('.form-loader').removeClass('d-none');
    $('.info-box').addClass('d-none');
    $('#nextBtn').addClass('d-none');
    $('#prevBtn').addClass('d-none');
    $('.admin-modal .step').addClass('d-none');
    $.ajax({
        'method': 'POST',
        'url': '/ajax/create-commission',
        'data': $('#build-commission').serialize(),
        success: function(response){
            showFormFields();
            if(response.success){
                $('#build-commission').data('tab', 0);
                showTab(0);
                $('#modal-commission .btn-close').trigger('click');
                $('input[name="budget"]').val('');
                table.ajax.reload();
                Swal.fire({
                    title: 'Operazione riuscita',
                    text: 'Hai assegnato con successo un incarico per l\'operatore ' + $('[name="user_id"] option:selected').text(),
                    icon: 'success',
                });
            } else {
                Swal.fire({
                    title: 'Si è verificato un problema',
                    text: 'Non è stato possibile creare l\'incarico sul donatore',
                    icon: 'error',
                });
                return false;
            }
        },
        error: function(){
            showFormFields();
            Swal.fire({
                title: 'Si è verificato un problema',
                text: 'Non è stato possibile creare l\'incarico sul donatore',
                icon: 'error',
            });
            return false;
        }
    });
}

function showFormFields()
{
    $('.form-loader').addClass('d-none');
    $('.info-box').removeClass('d-none');
    $('#nextBtn').removeClass('d-none');
    $('#prevBtn').removeClass('d-none');
    $('.admin-modal .step').removeClass('d-none');
}

function validateForm()
{
    let valid = true;
    let index = $('#build-commission').data('tab');
    $('.step').eq(index).removeClass('finish');
    $('.tab').eq(index).find("input").removeClass('invalid');
    $('.tab').eq(index).find("select").removeClass('invalid');
    $(".tab").eq(index).find("input").each(function(){
        if($(this).val() == ''){
            $(this).addClass('invalid')
            valid = false;
        }
    });
    $(".tab").eq(index).find("select").each(function(){
        if($(this).val() == ''){
            $(this).addClass('invalid')
            valid = false;
        }
    });
    if(valid) {
        $('.step').eq(index).addClass('finish');
    }
    return valid;
}

function allSameHeight(){
    let max = 0;
    $('.same-height').each(function(){
        let h = $(this).innerHeight();
        if(h > max){
            max = h;
        }
    });
    $('.same-height').css('height', max)
}